import { StyleSheet } from "react-native";

import { useContentResource } from "@ctv/core";
import { Card, Radio, Text, Token, View } from "@ctv/shared-core/src";
import { PropsWithChildren } from "react";
import { PaymentMethod } from "../../../types";

type Props = {
  title: string;
  benefits: string;
  description: string;
  icon: React.ReactNode;
  value: PaymentMethod;
  checked?: boolean;
  onChange(value: PaymentMethod): void;
};

export default function RadioPaymentMethod({
  icon,
  title,
  checked,
  benefits,
  children,
  value,
  onChange,
  description,
}: PropsWithChildren<Props>) {
  const { CorporateRegistration: cr } = useContentResource();
  return (
    <Card>
      <View style={styles.optionContentWrapper}>
        <Radio
          style={styles.radioOption}
          value={value}
          checked={checked}
          onChange={onChange}
        >
          <View style={styles.radioContent}>
            <View row align="center" spacing="s">
              {icon}
              <Text variant="title-2">{title}</Text>
            </View>
            <Text variant="ui-tiny" style={styles.marginTopS}>
              {description}
            </Text>
            <Text variant="ui-tiny-bold" style={styles.marginTopS}>
              {cr.benefits}
            </Text>
            <Text variant="ui-tiny">{benefits}</Text>
          </View>
        </Radio>
      </View>
      {checked && children}
    </Card>
  );
}

const styles = StyleSheet.create({
  optionContentWrapper: {
    padding: Token.spacing.l,
  },
  radioOption: {
    gap: Token.spacing.xs,
  },
  radioContent: {
    flex: 1,
  },
  // General styles
  marginTopS: {
    marginTop: Token.spacing.s,
  },
});
